import { EasyAvatar } from "fin-web-components";
import { Tooltip } from "antd";
import { CS_AVATAR_URL } from "./CustomerServiceChatTypes";
import "./CustomerServiceChatStyle.css";

type Props = {
  onClick: () => void;
  className?: string;
  title?: string;
  /** 不传则使用平台客服默认头像 */
  avatarUrl?: string;
  avatarWord?: string;
};

/** 全站右下角悬浮客服入口（与顶栏 .shell-top-inner 内容区右缘对齐） */
export function CustomerServiceFloatEntry(props: Props) {
  const { onClick, title = "平台客服", avatarUrl, avatarWord = title } = props;
  const resolvedAvatarUrl = avatarUrl?.trim() || CS_AVATAR_URL;
  return (
    <div className="lf-cs-float-entry" aria-hidden={false}>
      <Tooltip
        title={title}
        placement="top"
        mouseEnterDelay={0.15}
        mouseLeaveDelay={0}
        color="rgba(40, 40, 40, 0.92)"
        overlayClassName="lf-cs-entry-tooltip"
        getPopupContainer={() => document.body}
      >
        <button
          type="button"
          className="lf-cs-float-entry-btn"
          aria-label={title}
          onClick={onClick}
        >
          {avatarUrl?.trim() ? (
            <EasyAvatar
              shape="circle"
              size={42}
              url={resolvedAvatarUrl}
              word={avatarWord}
              alt=""
              className="lf-cs-float-entry-avatar"
            />
          ) : (
            <img src={CS_AVATAR_URL} alt="" draggable={false} />
          )}
        </button>
      </Tooltip>
    </div>
  );
}

/** 顶栏客服图标入口 */
export function CustomerServiceIconButton(props: Props) {
  const { onClick, className, title = "平台客服" } = props;
  return (
    <Tooltip
      title={title}
      placement="bottom"
      mouseEnterDelay={0.15}
      mouseLeaveDelay={0}
      color="rgba(40, 40, 40, 0.92)"
      overlayClassName="lf-cs-entry-tooltip"
      getPopupContainer={() => document.body}
    >
      <button
        type="button"
        className={["lf-cs-entry-icon-btn", className].filter(Boolean).join(" ")}
        aria-label={title}
        onClick={onClick}
      >
        <img src={CS_AVATAR_URL} alt="" draggable={false} />
      </button>
    </Tooltip>
  );
}

/** 文字链入口（footer / 顶栏） */
export function CustomerServiceTextEntry(props: Props & { label?: string }) {
  const { onClick, className, label = "平台客服" } = props;
  return (
    <button type="button" className={["lf-cs-entry-link", className].filter(Boolean).join(" ")} onClick={onClick}>
      {label}
    </button>
  );
}
